import React from 'react';
import {
  HMCDuo, HMCGame, HMCHome, HMCPlay, HMCSolo, HMCTrio, HMCTwitter, BellIcon, GearsIcon, TruckIcon, RouterIcon,
  PricePromiseIcon,
  ShoppingIcon,
  AccessoriesIcon,
  OfferBadgeIcon
} from 'src/Components/Common';
import CalenderIcon from 'src/Components/Common/Svg/CalenderIcon';
import DocumentIcon from 'src/Components/Common/Svg/DocumentIcon';
import FirstIcon from 'src/Components/Common/Svg/FirstIcon';
import FreeTrialIcon from 'src/Components/Common/Svg/FreeTrialIcon';
import OnlineExperienceIcon from 'src/Components/Common/Svg/OnlineExperienceIcon';
import PaymentIcon from 'src/Components/Common/Svg/PaymentIcon';
import PremiumIcon from 'src/Components/Common/Svg/PremiumIcon';
import PublicWifiIcon from 'src/Components/Common/Svg/PublicWIfiIcon';
import SecondIcon from 'src/Components/Common/Svg/SecondIcon';
import ThirdIcon from 'src/Components/Common/Svg/ThirdIcon';
import SmartRouterIcon from 'src/Components/Common/Svg/SmartRouterIcon';
import UmbrellaIcon from 'src/Components/Common/Svg/UmbrellaIcon';
import GreenRouterIcon from 'src/Components/Common/Svg/GreenRouterIcon';
import GreenCalenderIcon from 'src/Components/Common/Svg/GreenCalenderIcon';
import GreenSpeedIcon from 'src/Components/Common/Svg/GreenSpeedIcon';
import GreenValueIcon from 'src/Components/Common/Svg/GreenValueIcon';

export const HelpMeChooseCategories = [
  {
    id: 1,
    enterpriseType: 'Home',
    title: 'Working at home',
    imgSrc: <HMCHome />,
    isSelected: false
  },
  {
    id: 2,
    enterpriseType: 'Video',
    title: 'Video streaming',
    imgSrc: <HMCPlay />,
    isSelected: false
  },
  {
    id: 3,
    enterpriseType: 'Game',
    title: 'Online gaming',
    imgSrc: <HMCGame />,
    isSelected: false
  },
  {
    id: 4,
    enterpriseType: 'Media',
    title: 'Social media',
    imgSrc: <HMCTwitter />,
    isSelected: false
  }
];

export const HelpMeChooseUserCountOptions = [
  {
    id: 1,
    isSelected: false,
    title: '1 - 2 people',
    imgSrc: <HMCSolo />,
    peopleConnected: '1-2',
    enterpriseTypeNumber: '1To2'
  },
  {
    id: 2,
    isSelected: false,
    title: '3 - 5 people',
    imgSrc: <HMCDuo />,
    peopleConnected: '3-5',
    enterpriseTypeNumber: '3To5'
  },
  {
    id: 3,
    isSelected: false,
    title: 'More than 5 people',
    imgSrc: <HMCTrio />,
    peopleConnected: '5-100',
    enterpriseTypeNumber: '5plus'
  }
];

export const OTPTypes = {
  SMS: 'SMS',
  Email: 'EMAIL'
};

export const PackageTypes = {
  PremiumFibreDeals: 'Premium Fibre Deals',
  StandaloneFibreDeals: 'Standalone Fibre Deals',
  VodacomOneDeals: 'Vodacom One Deals'
};

export const PackageTypesDisplayNames = {
  [PackageTypes.PremiumFibreDeals]: 'Premium',
  [PackageTypes.StandaloneFibreDeals]: 'Fibre Only',
  [PackageTypes.VodacomOneDeals]: 'Vodacom One'
};

export const SessionsKeys = {
  FibreLeadsAddress: 'fibreLeadsAddress',
  FTTH_MA: 'ftthMA',
  ProactiveSalesFlag: 'proactiveSalesFlag',
  Products: 'products',
  TrackingIds: 'trackingIds',
  FibreRedirectAddress: 'fibreRedirectAddress'
};

export const SortOrders = {
  ASC: 'ascending',
  DESC: 'descending'
};

export const DealSortOrders = {
  ASC: 'Price - Low to high',
  DESC: 'Price - High to low'
};

export const ContactUs = {
  Email: 'ftthonline@vodacom.co.za',
  Phone: '082 1904',
  whatsapp: '',
  claimsEmail: 'deceased@vodacom.co.za'
};

export const SalesFooter = [
  {
    icon: <BellIcon />,
    step: 1,
    heading: 'Order confirmation',
    description: 'Once you\'ve placed your order, you\'ll receive a confirmation email with your sales order number.'
  },
  {
    icon: <TruckIcon />,
    step: 2,
    heading: 'Router delivery',
    description: 'Your router will be delivered to your doorstep within 1-3 business days.'
  },
  {
    icon: <GearsIcon />,
    step: 3,
    heading: 'Fibre installation',
    description: 'We\'ll connect you within 7 days.'
  },
  {
    icon: <RouterIcon />,
    step: 4,
    heading: 'Router activation',
    description: 'Easily activate your router yourself! Watch our YouTube video to learn how to connect your fibre devices.',
    hasVideo: true
  }
];

export const ContractCoverPlus = 'Affordable insurance that covers your Vodacom contract in the event of your death and provides R5,000 for funeral expenses. ';

export const SuperWifi = 'Boost WiFi coverage throughout your home, with a free 14-day trial once your fibre is installed and activated. ';

export const ContractCoverInclusions = [
  {
    icon: <UmbrellaIcon />,
    topic: 'Cover in the event of your death',
    description: 'A lump sum benefit is paid to ensure that your outstanding subscription costs are paid for.'
  },
  {
    icon: <CalenderIcon />,
    topic: 'Convenient monthly payments',
    description: 'For your convenience, premiums are added to your monthly fibre bill.'
  },
  {
    icon: <PremiumIcon />,
    topic: 'One affordable premium for all plans',
    description: 'You’ll only pay one premium of R9.99 per month regardless of the price plan you’re on.'

  },
  {
    icon: <DocumentIcon />,
    topic: 'Easy claims process',
    description: 'To process your claim, we require a certified death certificate and ID copy.'
  }
];

export const SuperWifiInclusions = [
  {
    icon: <PublicWifiIcon />,
    topic: 'Comprehensive WiFi coverage',
    description: 'Super WiFi provides fast, reliable WiFi coverage to every corner of your home, eliminating frustrating WiFi dead zones.'
  },
  {
    icon: <SmartRouterIcon />,
    topic: 'Smart and dynamic network',
    description: 'Super WiFi\'s small WiFi access points work together with your Vodacom home broadband router to create a smart and dynamic network that adapts to provide the best possible connection for your home and connected devices.'
  },
  {
    icon: <OnlineExperienceIcon />,
    topic: 'Seamless online experience',
    description: 'Enjoy a seamless online experience with Super WiFi, ensuring everyone in your home can enjoy uninterrupted streaming, gaming, and browsing.'
  },
  {
    icon: <FreeTrialIcon />,
    topic: 'Free trial',
    description: 'Experience the benefits of Super WiFi with a FREE 14-day trial once your fibre is installed and activated. '
  },
  {
    icon: <PaymentIcon />,
    topic: 'Flexible payment option',
    description: 'Your Super WiFi router will be delivered upon activation, but you\'ll only start paying for it when the trial period is over, giving you ample time to experience its benefits before making a commitment.'
  }
];

export const SuperWifiFaqs = [
  {
    topic: 'Why would I require the Vodacom Super WiFi mesh solution?',
    description: 'The Vodacom Super Wi-Fi mesh solution extends the WiFi signal throughout your home eliminating WiFi “dead spots”. The Beacons are placed strategically in the home to maximum WiFi coverage. The Vodacom Super WiFi mesh solution allows for seamless connectivity throughout the home and gives you control over your WiFi network through an intuitive mobile app.'
  },
  {
    topic: 'Can beacons connect to other brands’ mesh solution?',
    description: 'No, interoperability is currently not supported'
  },
  {
    topic: 'How many beacons can I install in my home?',
    description: 'Currently the Vodacom Super Wi-Fi solution can support up to 4 Beacons (3 Beacons will be visible on the Mobile App). Future firmware updates will allow for a total of 6 Beacons being supported.'
  },
  {
    topic: 'What are the key features of the Vodacom Super WiFi mesh solution?',
    description: '',
    details: [
      'An easy to use mobile app available to download from the Google and iStore which guides you through the setup process.',
      'Real-time spectrum analysis and channel AI to detect and resolve any interference (Wi-Fi, microwaves, Bluetooth devices, etc.), ensuring the best possible channel selection.',
      'Fast rerouting on the backhaul in case of link failure (as fast as 500ms).',
      'Mesh for whole home coverage.',
      'High-performance antennas.'
    ]
  },
  {
    topic: 'What are WiFi “dead spots”?',
    description: 'A dead spot is an area within your house or apartment where wireless devices are unable able to connect to the WiFi network due to limited or no WiFi coverage from the router / gateway.'
  }
];

export const ContractCoverFaqs = [
  {
    topic: 'When will my cover start?',
    description: 'Your Contract Cover starts immediately once your payment for your fibre contract begins.\nIn some cases, you may receive a phone call from an insurance sales agent to finalise your Contract Cover application. If this happens, your cover will be activated as soon as the application is completed.'
  },
  {
    topic: 'What happens when I change my contract?',
    description: 'In the event that you change your contract, your existing contract cover will be terminated and you will have to request that Contract Cover be added to your new contract.'
  },
  {
    topic: 'What is Contract Cover Plus?',
    description: '',
    details: [
      'If you should die during the period of insurance, we will pay a lump sum benefit equal to all the subscription fees and device financing costs in respect of the outstanding term of your Vodacom contract. This benefit will be paid to Vodacom (Pty) Ltd to fulfill your contractual obligation to Vodacom (Pty) Ltd.',
      'An amount of R5,000 will also be paid to your chosen beneficiary or to your estate, if a beneficiary is not chosen to assist with any death-related costs.',
      'The rights under this policy are limited to your Vodacom contract. This policy cannot be used to protect any person other than you.'
    ]
  }
];

export const Claim = [
  {
    icon: <FirstIcon />,
    topic: 'Email claims department',
    description: 'Your chosen beneficiary can email us at deceased@vodacom.co.za to lodge a claim.'
  },
  {
    icon: <SecondIcon />,
    topic: 'Send certified documentation',
    description: 'Your beneficiary must submit a certified copy of the death certificate and ID of the deceased, along with the VodaSure Contract Cover Claims form, to initiate the claim process.'
  },
  {
    icon: <ThirdIcon />,
    topic: '180 days to submit',
    description: 'Your beneficiary must submit the claim within a maximum of 180 days.'
  }
];

export const isValidSAMsisdn = (msisdn) => {

  const mobileNumberReg = /((?:\+27)|27|0)(6|7|8)(\d{8})/;
  const numberReg = /(^([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$)|(^((0(\d{13}))|(0(\d{9}))|(\+?27(\d{13}))|(\+?27(\d{9})))$)/;

  return mobileNumberReg.test(msisdn) && numberReg.test(msisdn);
};

export const PrepaidFibreUrls = {
  'wwwdev.vodacom.co.za': 'https://wwwqa.vodacom.co.za/fibre/prepaid',
  'wwwqa.vodacom.co.za': 'https://wwwqa.vodacom.co.za/fibre/prepaid',
  'wwwstg.vodacom.co.za': 'https://www.vodacom.co.za/fibre/prepaid',
  'www.vodacom.co.za': 'https://www.vodacom.co.za/fibre/prepaid',
  'localhost': 'https://wwwqa.vodacom.co.za/fibre/prepaid'
};

export const VPPPopupTerms = {
  'title': 'Unable to process customer',
  'subtitle': 'We are unable to process this customer on our system at this time.',
  'detailsHeading': 'To complete this order, please:',
  'details': [
    'Use the manual form: Fill out the provided form and submit it to your business partner.',
    'Load the order on VPP: Follow the VPP guidelines to process the order.'
  ]
};

export const WhyChooseVodacomFibreFormTerms = [
  {
    icon: <GreenRouterIcon />,
    heading: 'Free setup & router',
    description: 'Get connected without extra costs. Installation, activation, and a Wi-Fi router are all included.'
  },
  {
    icon: <GreenCalenderIcon />,
    heading: 'Flexible plans',
    description: 'Choose from affordable month-to-month fibre options that suit your budget and lifestyle.'
  },
  {
    icon: <GreenSpeedIcon />,
    heading: 'Fast & reliable speeds',
    description: 'Enjoy uncapped fibre with consistent performance for work, play, and streaming.'
  },
  {
    icon: <GreenValueIcon />,
    heading: 'Great value',
    description: 'Fibre deals start from just R429 PM, with special offers to help you save more.'
  }
];

export const provinces = [ 'Eastern Cape',
  'Free State',
  'Gauteng',
  'KwaZulu-Natal',
  'Limpopo',
  'Mpumalanga',
  'North West',
  'Northern Cape',
  'Western Cape' ];

export const WhyChooseVodacomFibreTerms = [
  {
    icon: <OfferBadgeIcon />,
    heading: 'Exclusive & personalised offers',
    description: 'Log in for personal recommendations and discover Online Exclusive offers you won’t find anywhere else!'
  },
  {
    icon: <AccessoriesIcon />,
    heading: 'Wide range of products',
    description: 'Shop the latest smartphones, tablets, laptops, smart tech and more, all in one place.'
  },
  {
    icon: <ShoppingIcon />,
    heading: 'Flexible payment options',
    description: 'Buy it once-off, pay it off in instalments, or get it on contract over 24, 36 or 48 months'
  },
  {
    icon: <PricePromiseIcon />,
    heading: 'Safe, simple & seamless',
    description: 'Easy browsing, secure checkout, and fast delivery for a hassle-free shopping experience'
  }
];

export const cardKey = {
  lowestPrice: 'Lowest price',
  mostPopular: 'Most popular',
  bestValue: 'Best value for money'
};

export const cardKeyMobile = {
  lowestPrice: 'Lowest price',
  mostPopular: 'Popular',
  bestValue: 'Best value'
};
